import React from 'react';
import { rawCommonPdfStyles } from 'common/components/PdfViewModal/common.stylesheet';
import { Table } from './Table';
import { Transaction } from './Transaction';
import { InvoiceDetails } from 'common/components/Modules/TransactionEdit/graphql/__generated__/InvoiceDetails';
import { InvoiceTransactionTypes } from 'common/components/Modules/TransactionEdit/graphql/__generated__/InvoiceTransactionTypes';
import { usePdfRenderer } from 'common/hooks/usePdfRenderer';

export interface PdfDocumentProps {
  invoiceData?: InvoiceDetails;
  transactionTypeData?: InvoiceTransactionTypes;
}

export const TransactionPDF: React.FC<PdfDocumentProps> = ({
  invoiceData,
  transactionTypeData,
}) => {
const { Document, Page, PDFViewer, View, getStyleSheet } = usePdfRenderer();
   const commonPdfStyles = getStyleSheet(() => rawCommonPdfStyles);

if (!PDFViewer || !Document || !Page || !View || !Image || !commonPdfStyles)
  return null;
  return (
    <PDFViewer style={{ flex: 1 }}>
      <Document>
        <Page size="A4" style={commonPdfStyles.page}>
          <View style={{ flex: 1 }}>
            <Transaction
              invoiceData={invoiceData}
              transactionTypeData={transactionTypeData}
            />
            {invoiceData && (
              <Table
                data={invoiceData}
                transactionTypeData={transactionTypeData}
              />
            )}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
